import { canUseWebP } from 'js/utils/general';

// Target site ID
export const DOM_ID = 'react-microsite';

// Localstorage
export const LOCAL_STORAGE_NAME = 'bluey_microsite';

// base urls
export const BASE_URL = window?.siteData?.base_url ? window.siteData.base_url + '/' : import.meta.env.VITE_BASE_URL;
export const ASSET_URL = window?.siteData?.asset_url ? window.siteData.asset_url + '/' : BASE_URL;
export const BASE_API_URL = window?.siteData?.api_url
  ? window?.siteData.api_url + '/'
  : import.meta.env.VITE_BASE_API_URL;

// Picture mappings
export const WEBPSUPPORT = canUseWebP();

export const CACHEBUST = window?.siteData?.cachebust ? window.siteData.cachebust : '';

// Language
export const LANGUAGE = window.siteData?.locale ?? 'en_GB';

// copyright label
export const COPYRIGHT = 'THE BLUEY MOVIE TM & © Judo Pty Ltd ' + new Date().getFullYear();
